
//import store from '@/store'
const baseResponseHandler = {
  fulfilled: response => {
    return response;
  },
  rejected: error => {
    const { config } = error;
    const msg = `${config.method} : ${config.url}`;
    const isDev = process.env.NODE_ENV === 'development';
    isDev && console.error(error, msg);
    return Promise.reject(error);
  }
};
export default baseResponseHandler
